import { VideoDescriptionService } from "../../libs/ui/src/abstractServices/apiServices";
import { mlClient } from "../apiService";

export const videoDescriptionService = new VideoDescriptionService({client: mlClient});